<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
import { store } from '../../store';

export default {
  name: 'slide1',
  created() {
    this.$watch('$route.meta', (newVal) => {
      this.autoStartClip = !newVal.intro;
    }, { immediate: true });
	this.$watch('store.lang', newVal => {
		if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
			this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
		}
	}, { immediate: true });
    const unwatch = this.$watch('$tutorial.value', newVal => {
      this.autoStartClip = newVal;
      this.emitter.emit('auto-play');
	  unwatch();
    });
  },
  mounted() {
    const self = this;
    const audio = '/themes/rise-theme/resources/assets/audio/vanessa/1.mp3';
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/1.jpg',
          url: 'https://oaklandside.org/2021/08/18/oaklands-population-grew-by-50000-over-the-past-decade-2020-census-data-shows/',
          link_title: {
			'en': 'Oakland’s population grew by 50,000 over the past decade',
			'es': 'La población de Oakland creció en 50,000 durante la última década'
		  },
        }
      ],
      text: {
		'en': 'In 1980, Black residents made up half of Oakland residents. In 1990, Black residents made up 44%, and the population has continued to decline more dramatically in recent years. By 2022, Black residents only make up 23% of the city\'s population.',
		'es': 'En 1980, los residentes negros constituían la mitad de los residentes de Oakland. En 1990, los residentes negros constituían el 44% y la población ha seguido disminuyendo de forma más drástica en los últimos años. Para 2022, los residentes negros solo representan el 23% de la población de la ciudad.'
	  }
    };
    const text = {
		'en': 'At the time Vanessa moved Oakland, the city\'s Black population had grown to 47% and the city was known as a center of Black arts and culture.',
		'es': 'Cuando Vanessa se mudó a Oakland, la población negra de la ciudad había crecido al 47% y la ciudad era conocida como un centro de arte y cultura negros.'
	};
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(200px) rotateZ(-30deg)') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$audioUrl.value = audio;
		  this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#slide1'), {
      attributes: true,
      attributeFilter: ['style']
    });

    this.$audioUrl.value = audio;
	this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
    this.$readMore.value = text;
    this.$evidence.value = JSON.stringify(evidence);
	// console.log('player ready listener');
    self.emitter.on('player-ready', () => {
		console.log('player-ready event catch')
      setTimeout(() => {
        if(self.autoStartClip) {
          self.emitter.emit('auto-play');
        }
      }, 500);
    });

  },
  unmounted() {
	  this.mutationObserver.disconnect();
  },
  data() {
    return {
	  store,
	  subtitlesUrl: {
		'en': '/themes/rise-theme/resources/assets/audio/vanessa/1.srt',
		'es': '/themes/rise-theme/resources/assets/audio/vanessa/1_es.srt'
	  },
	  mutationObserver: null,
      autoStartClip: true,
      parallax: [
        {
          start: 0,
          end: 400,
          fromStyle: { transform: 'translateY(0px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(200px) rotateZ(-30deg)' },
          easing: 'linear'
        },
        {
          start: 850,
          end: 1200,
          fromStyle: { transform: 'translateY(200px) rotateZ(-30deg)' },
          toStyle: { transform: 'translateY(2000px) rotateZ(-45deg)' },
          easing: 'linear'
        }
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/01_Photo_01.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 400px;
    height: 500px;
    left: -200px;
    top: 32vh;
    transition: 0.2s;

    @media(max-width: 600px) {
      width: 170px;
      left: -85px;
      top: 200px;
    }
    @media(max-width: 400px) {
      top: 20px;
    }
}
</style>
